import React from 'react';

interface PlatformIconProps {
  platformKey: string;
  icon: string;
  size?: number;
  className?: string;
}

export const PlatformIcon: React.FC<PlatformIconProps> = ({ platformKey, icon, size = 24, className = '' }) => (
  <span
    className={`platform-icon-mask ${className}`}
    style={{
      display: 'inline-block',
      width: size,
      height: size,
      maskImage: `url(${icon})`,
      WebkitMaskImage: `url(${icon})`,
      maskSize: 'contain',
      WebkitMaskSize: 'contain',
      maskRepeat: 'no-repeat',
      WebkitMaskRepeat: 'no-repeat',
      maskPosition: 'center',
      WebkitMaskPosition: 'center',
      backgroundColor: `var(--color-platform-${platformKey})`,
    } as React.CSSProperties}
    role="img"
    aria-label={`${platformKey} icon`}
  />
);
